import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { ListMetadata } from '../../models/list-metadata.model';
import { Layout, LayoutDetail } from '../../models/loyalty-layout.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class LoyaltyLayoutService {

  public baseUrl = '/koncentro-loyalty';
  private cachedFields: Observable<any>;

  constructor(
    private srvNotify: MessageService,
    private http: HttpClientService
  ) { }

  get(layoutId): Observable <Layout> {
    return this.http.get(this.baseUrl + '/layout/' + layoutId);
  }

  list (
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
  ): Observable<{ data: Array<Layout> , metadata: ListMetadata }> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/layout/getLayoutList?'  + params.toString());
  }

  update(layout: Layout): Observable<Layout> {
    return this.http.put(this.baseUrl + '/layout/' + layout.id, layout);
  }

  create(layout: Layout): Observable<Layout> {
    return this.http.post(this.baseUrl + '/layout/', layout);
  }

  remove(layoutId): Observable<Layout> {
    return this.http.delete(this.baseUrl + '/layout/' + layoutId);
  }

  recover(layout) {
    return this.http.put(this.baseUrl + '/layout/recover/' + layout.id, layout)
      .map(res => {
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
    }

  getChild(layoutId): Observable<{ data: Array<LayoutDetail>, metadata: ListMetadata }> {
    return this.http.get(this.baseUrl + '/layout/' + layoutId + '/detail');
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get(`${this.baseUrl}/schema/LayoutDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/layout.service.ts